import React, { useState } from "react";
import { UploadStatus, Video } from "../common/ObjectTypes";
import UnauthorizedResponse from "../../helpers/UnauthorizedResponse";

// Define the props for the form
type UploadVideoFormProps = {
  onFileInputChange: React.ChangeEventHandler<HTMLInputElement>;
  onUpload: Function;
  uploadStatus: UploadStatus;
  video: Video;
  onBitmovinEncode: Function;
  isDisabled?: boolean; // Added isDisabled prop
};

// The main component
const UploadVideoForm: React.FC<UploadVideoFormProps> = ({
  onFileInputChange,
  onUpload,
  uploadStatus,
  video,
  onBitmovinEncode,
  isDisabled = false,
}) => {
  // If the user doesn't have permission, show the unauthorized message
  if (isDisabled) {
    return (
      <UnauthorizedResponse
        message="You don't have permission to edit this video. Only system administrators or users in the same organization can modify this content."
        redirectUrl="/"
      />
    );
  }

  return (
    <div className="mt-20 flex items-center justify-center bg-gray-100">
      <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-md">
        <h3 className="text-2xl font-semibold text-center mb-4 text-gray-700">
          Upload Video
        </h3>
        <input
          type="file"
          accept="video/*"
          onChange={onFileInputChange}
          className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-deepGreen-50 file:text-deepGreen-700 hover:file:bg-deepGreen-100 mb-4"
        />

        <button
          onClick={() => onUpload()}
          className={
            uploadStatus && uploadStatus.uploadStatusId === 2
              ? "hidden"
              : "w-full bg-deepGreen-600 hover:bg-deepGreen-700 text-white py-2 rounded-lg text-lg transition duration-300"
          }
        >
          Upload
        </button>
        {uploadStatus && (
          <p className="my-4 text-center text-gray-600">
            {uploadStatus.message}
          </p>
        )}
        {uploadStatus && uploadStatus.uploadStatusId === 2 && (
          <>
            <button
              onClick={() => onBitmovinEncode(video.videoId)}
              className="w-full bg-deepGreen-600 hover:bg-deepGreen-700 text-white py-2 rounded-lg text-lg transition duration-300"
            >
              Encode Video
            </button>{" "}
          </>
        )}
      </div>
    </div>
  );
};

export default UploadVideoForm;
